import { render, staticRenderFns } from "./historyOmit.vue?vue&type=template&id=67346f8e&"
import script from "./historyOmit.vue?vue&type=script&lang=js&"
export * from "./historyOmit.vue?vue&type=script&lang=js&"
import style0 from "./historyOmit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports